module.exports = __webpack_public_path__ + "static/img/industries6.2a6657e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries6.png
// module id = 5bq/
// module chunks = 1